import BASE_URL from "../config";

const json = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

const DEFAULT_SETTINGS = {
  shippingFee: 0,
  freeShippingAbove: null,
  codFee: 0,
  codEnabled: true,
  codAdvanceEnabled: false,
  codAdvanceAbove: 1500,
  codAdvanceAmount: 49,
  codAdvanceHighAbove: null,
  codAdvanceHighAmount: 99,
  codAdvanceCoversDelivery: false,
  codRequiresAccount: true,
  prepaidDiscountType: "none",
  prepaidDiscountValue: 0,
  prepaidDiscountMax: null,
  deliveryMinDays: 4,
  deliveryMaxDays: 6,
  addOnMaxPrice: 0,
};

// Shipping / COD charges, so the checkout can show them from the first screen.
export const getCheckoutSettings = async () => {
  try {
    const result = await json(await fetch(`${BASE_URL}/settings/checkout`));
    return result.ok && result.success ? result.data : DEFAULT_SETTINGS;
  } catch {
    return DEFAULT_SETTINGS;
  }
};

// { status: "valid" | "invalid" | "unverified", city?, state?, serviceable?, reason?, deliveryFrom?, deliveryTo?, minDays?, maxDays? }
// `serviceable: false` means we do not deliver there (reason "blocked" or "courier"). `cod` asks about Cash on Delivery.
export const checkPincode = async (pin, { cod = false } = {}) => {
  try {
    const result = await json(await fetch(`${BASE_URL}/settings/pincode/${encodeURIComponent(pin)}${cod ? "?cod=1" : ""}`));
    return result.ok && result.success ? result.data : { status: "unverified" };
  } catch {
    return { status: "unverified" };
  }
};

// The money rules live in one place (and are tested there); re-exported for the pages that already import them here.
export { computeCharges, computePrepaidDiscount, computeAdvance, computeCheckout } from "../utils/checkoutTotals";

export const adminSaveCheckoutSettings = async (payload, token) =>
  json(
    await fetch(`${BASE_URL}/settings/admin/checkout`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    })
  );

// Admin: the full settings, including the PIN codes we do not deliver to.
export const adminGetCheckoutSettings = async (token) =>
  json(await fetch(`${BASE_URL}/settings/admin/checkout`, { headers: { Authorization: `Bearer ${token}` } }));
